import { useContext, useEffect } from "react";
import AuthContext from "contexts/AuthContext";
import { Outlet, useLocation } from "react-router-dom";
import Intercom from "@intercom/messenger-js-sdk";

export default function IntercomProvider() {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const pathname = location.pathname;
  // const isKiosk = pathname.includes("en-US/kiosk");
  const isStoreorWarehouse =
    pathname.includes("en-US/store") || pathname.includes("/warehouse");
  const admin_user = Boolean(
    user?.email &&
      (user.email.endsWith("lego.com") || user.email.endsWith("pentatonic.com"))
  );

  // Initialize Intercom once on mount
  useEffect(() => {
    Intercom({
      app_id: "ged8p9l8",
      custom_launcher_selector: ".my_custom_launcher",
    });
  }, []);

  useEffect(() => {
    if (user) {
      Intercom("shutdown");
      Intercom("boot");
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      window.intercomSettings = {
        app_id: "ged8p9l8",
        custom_launcher_selector: ".my_custom_launcher",
        ...(user?.email && {
          email: user.email,
          name: user.first_name,
          user_first_name: user.first_name,
          admin_user: admin_user,
        }),
        ...(isStoreorWarehouse ? { hide_default_launcher: true } : {}),
      };
    } else {
      window.intercomSettings = {
        app_id: "ged8p9l8",
        custom_launcher_selector: ".my_custom_launcher",
        ...(isStoreorWarehouse ? { hide_default_launcher: true } : {}),
      };
    }
  }, [user, admin_user, isStoreorWarehouse]);

  return <Outlet />;
}
